import React from "react";

const GridViewFooter = (props) => {
    const { actions, freights } = props;
    const handleClickTrades = () => {
        actions.showCompletedTradesPopup()
    }
    const handleClickExpired = () => {
        actions.showExpiredOrdersPopup()
    }

    return (
        <div className="OnlineMarketsGridViewFooterWrapper">
            <div className="OnlineMarketsGridViewFooterButtonWrapper" >
                <div className="OnlineMarketsGridViewFooterButton" onClick={handleClickTrades}>
                    Trades
                </div>
                <div className="OnlineMarketsGridViewFooterButton" onClick={handleClickExpired}>
                    Expired
                </div>
            </div>
        </div>
    );
}

export {GridViewFooter}


// WEBPACK FOOTER //
// ./source/components/OnlineMarketsGridViewFooter.js